import { render, staticRenderFns } from "./Destination.vue?vue&type=template&id=22fe2c32&scoped=true"
import script from "./Destination.vue?vue&type=script&lang=js"
export * from "./Destination.vue?vue&type=script&lang=js"
import style0 from "./Destination.vue?vue&type=style&index=0&id=22fe2c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fe2c32",
  null
  
)

export default component.exports